export class OfferBannerAttachmentModel {
    id: number;
    name: string;
    contentType: string;
    url: string;
    size?: number;
}
